<template>
  <g-dropdown-wrap
    :value="value"
    class="custom-select -mr-2"
    @selected="onSelected"
    :open-item.sync="open">
    <template v-slot:selected="slotProps">
      <span
        class="-color-gray-1 -mx-0 -px-0 -font-size-12 -font-weight-medium -btn"
        @click="onClickOpen">
        <span>{{slotProps.selected.selectedText}}</span>
        <g-icon tag="span" :name="dropIcon" width="16px" height="16px"></g-icon>
      </span>
    </template>
    <slot></slot>
  </g-dropdown-wrap>
</template>
<script>
import {AUTH_GROUP} from "@/constants/constants";
import moment from "moment";
import {mapActions, mapGetters} from "vuex";
import UsageCostAndPaymentStatusDummy from "@/pages/home/components/UsageCostAndPaymentStatusDummy.json";

export default {
  name: 'span-dropdown',
  props: {
    value: {
      type: String,
      default: ''
    },

    //  seriesList: [],
  },
  data () {
    return {
      open: false,
      selectedValue: this.value,
      isLineGraph: false
    }
  },
  computed: {

    dropIcon () {
      return this.open ? 'arrow_drop_up' : 'arrow_drop_down'
    },
  },
  watch:{
   // this.monthParam = value
  },
  methods: {
   // ...mapActions('contract', ['getContractsGetChartData']),
    onClickOpen () {
      this.open = !this.open
    },
    onSelected (value, text) {
      this.monthParam = value;
      this.selectedValue = value;
      this.selectedText = text;

      this.$emit('selected', {text,value});
// this.$emit('on-selected',param)
    //  this.$emit('choose', this.selectedMonthValue);
    },
    getChartData(){
     /* var date = new Date();

      let param = {};
      param.companyCode = 1000;
     // param.companyCode = this.userInfo.companyCode;

      if (this.userInfo.auth === AUTH_GROUP.BespinSales)  {
        param.empNo = this.userInfo.empNo;
      }else{
        param.empNo = '';
      }
      if(this.monthParam === ''){
        param.startMonth = moment(date.getTime()).add("-6", "M").format("YYYYMM")

      }else{

        let month = "-"+(parseInt(this.monthParam)-1);
        param.startMonth = moment(date.getTime()).add(month, "M").format("YYYYMM")

      }
      param.endMonth = moment(date.getTime()).add("0", "M").format("YYYYMM")

      this.getContractsGetChartData(param);

      let index ;
      console.log(" this.contractChartData::", this.contractChartData);
      console.log(" this.contractSeriesList::", this.contractSeriesList);
      this.chartData = this.contractChartData;
      this.seriesList = this.contractSeriesList;

      console.log();*/
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/contract/components/components/SpanDropdown.vue